import { IFormItemProps } from '@/components';

export type TFormValidatorRule = NonNullable<IFormItemProps['rules']>[number];

export enum AmountSelectMeta {
  UP = 'up',
  DOWN = 'down',
}
